import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import type { AnyRoute } from '@tanstack/react-router'
import { i18n } from '../../shared/i18n/i18n'
import sv from './locales/sv.json'
import en from './locales/en.json'

i18n.addResourceBundle('sv', 'misc', sv, true, true)
i18n.addResourceBundle('en', 'misc', en, true, true)

// Static info pages that have no BE backing. Lumped under a single feature
// folder so we don't proliferate one-file features.
export function buildMiscRoutes<TParent extends AnyRoute>(parent: TParent) {
  return [
    createRoute({
      getParentRoute: () => parent,
      path: '/help',
      component: lazyRouteComponent(
        () => import('./HelpPage'),
        'HelpPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/featureHistory',
      component: lazyRouteComponent(
        () => import('./FeatureHistoryPage'),
        'FeatureHistoryPage',
      ),
    }),
    createRoute({
      getParentRoute: () => parent,
      path: '/images',
      component: lazyRouteComponent(
        () => import('./ImagesPage'),
        'ImagesPage',
      ),
    }),
  ]
}
